/**
 * Promo strip on /home for the paid 50/50 shop.
 *
 * Sibling of `refer_fiftyfifty_banner.js` — same card shape so the two
 * stack cleanly when both flags are on. Blue palette to match the 50/50
 * icon chip + the live-room "Use 50/50" button, so the buy CTA is
 * visually distinct from the pink Refer & Earn banner.
 *
 * Admin-gated via the `home_banner_show_buy_fiftyfifty` feature flag
 * (server side: see app/api/home.py::HomePayload.show_buy_fiftyfifty_banner).
 * Links to /shop — the unified power-up storefront — so a tap on any
 * power-up CTA lands the user on the same page regardless of which
 * single-product banner is currently being promoted.
 */

export function buyFiftyfiftyBannerHtml() {
  return `
    <div
      class="card buy-fiftyfifty-banner"
      style="padding:8px 10px;margin-bottom:8px;background:linear-gradient(135deg,#15233F 0%,#1B3A6E 100%);border-color:rgba(127,180,255,0.55);"
    >
      <a href="/shop" data-link class="row"
         style="align-items:center;gap:8px;text-decoration:none;color:inherit;min-width:0;">
        <div style="font-size:18px;line-height:1;color:#7FB4FF;flex-shrink:0;">
          <svg viewBox="0 0 24 24" width="18" height="18"
               aria-hidden="true" style="display:block;">
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2.2"/>
            <path d="M12 3a9 9 0 0 0 0 18z" fill="currentColor" stroke="none"/>
            <line x1="12" y1="3" x2="12" y2="21" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="grow" style="min-width:0;">
          <div style="color:#fff;font-weight:700;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Buy 50/50s from ₦250
          </div>
          <div style="color:rgba(255,255,255,0.78);font-weight:500;font-size:10.5px;line-height:1.25;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Bundles of 1, 3 or 5 · pay with wallet or bonus credit.
          </div>
        </div>
        <span
          class="btn sm"
          style="padding:4px 10px;font-size:12px;line-height:1.2;flex-shrink:0;margin:0;background:rgba(127,180,255,0.22);border:1px solid rgba(127,180,255,0.55);color:#fff;font-weight:700;"
        >
          Shop
        </span>
      </a>
    </div>
  `;
}
